/**
 * Copy text to the clipboard. The Clipboard API only exists in secure contexts (HTTPS,
 * localhost) – apps on a plain-HTTP LAN address fall back to a hidden textarea. Resolves
 * to whether it worked, so callers never claim "copied" when nothing was copied.
 */
export async function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch {
            // e.g. denied permission – try the fallback
        }
    }

    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.setAttribute('aria-hidden', 'true');
    area.style.cssText = 'position:fixed;inset-block-start:0;inset-inline-start:0;opacity:0;pointer-events:none';

    // An open modal dialog makes the rest of the page inert: the textarea must live inside it.
    const host = [...document.querySelectorAll('dialog[open]')].pop() ?? document.body;
    const active = document.activeElement;
    host.append(area);
    area.select();

    let copied = false;
    try {
        copied = document.execCommand('copy');
    } catch {
        copied = false;
    }

    area.remove();
    active?.focus?.({ preventScroll: true });

    return copied;
}
